export const PORTAL_ROUTE_RULES = [
  { match: path => path === '/dashboard', permission: 'dashboard.view' },
  { match: path => path === '/ticketing/dashboard', permission: 'ticketing.view' },
  { match: path => path.startsWith('/tickets'), permission: 'ticketing.view' },
  { match: path => path === '/sites', permission: 'sites.view' },
  { match: path => path === '/eset-licenses', permission: 'eset.manage' },
  { match: path => path === '/bi', permission: 'bi.view' },
  { match: path => path === '/reception', permission: 'reception.view' },
  { match: path => path === '/kb', permission: 'kb.view' },
  { match: path => path === '/downloads', permission: 'downloads.view' },
  { match: path => path === '/documents', permission: 'documents.view' },
  { match: path => path.startsWith('/reports'), permission: 'reports.view' },
  { match: path => path === '/activity', permission: 'activity.view' },
  { match: path => path === '/settings', permissions: ['settings.manage', 'users.manage', 'downloads.manage'] },
  { match: path => path.startsWith('/assistant'), permission: 'assistant.view' },
  { match: path => path.startsWith('/parc'), permission: 'parc.view' },
  { match: path => path === '/messagerie', permission: 'voicemails.view' },
  { match: path => path === '/call-history', permission: 'voicemails.view' },
  { match: path => path === '/vault', permission: 'vault.view' },
  { match: path => path.startsWith('/incidents'), permission: 'incidents.view' },
  { match: path => path === '/calendar', permission: 'calendar.view' },
  { match: path => path.startsWith('/admin/docker'), permission: 'docker.manage' },
  { match: path => path.startsWith('/admin/vmware'), permission: 'vmware.manage' },
  { match: path => path.startsWith('/admin/proxmox'), permission: 'proxmox.manage' },
  { match: path => path.startsWith('/admin/snmp'), permission: 'snmp.manage' },
  { match: path => path === '/admin/scheduled-tasks', permission: 'scheduled_tasks.manage' },
  { match: path => path === '/admin/spooler', permission: 'spooler.manage' },
  { match: path => path === '/admin/rules', permission: 'spooler.manage' },
  { match: path => path.startsWith('/admin/agent'), permission: 'agent.execute' },
  { match: path => path === '/n8n', permission: 'n8n.manage' },
  { match: path => path.startsWith('/gestion'), permission: 'ticketing.admin' },
  { match: path => path.startsWith('/configuration'), permission: 'settings.manage' },
];

export const DEFAULT_PORTAL_PATHS = [
  '/dashboard',
  '/ticketing/dashboard',
  '/tickets',
  '/sites',
  '/eset-licenses',
  '/bi',
  '/reception',
  '/kb',
  '/downloads',
  '/documents',
  '/reports',
  '/activity',
  '/settings',
];

export function userHasPermission(user, permission, orgCode) {
  if (!permission) return true;
  if (!user) return false;
  if (user.role === 'superadmin') return true;
  // Cas 1 — orgCode fourni : check strict sur permissions_by_org[orgCode] si présent,
  // sinon fallback sur permissions racine (legacy).
  if (orgCode) {
    if (user.permissions_by_org && Array.isArray(user.permissions_by_org[orgCode])) {
      return user.permissions_by_org[orgCode].includes(permission);
    }
    return Array.isArray(user.permissions) && user.permissions.includes(permission);
  }
  // Cas 2 — pas d'orgCode : check permissions racine, ET check OR sur toutes les
  // orgs de permissions_by_org. Sinon les perms acquises via capacité métier
  // (qui ne sont JAMAIS en permissions racine, cf piège 13 reference_rights_architecture)
  // seraient invisibles aux call sites qui n'ont pas l'org active sous la main —
  // typiquement <ProtectedRoute permission="..."/> et les guards de bouton.
  if (Array.isArray(user.permissions) && user.permissions.includes(permission)) {
    return true;
  }
  if (user.permissions_by_org && typeof user.permissions_by_org === 'object') {
    for (const orgPerms of Object.values(user.permissions_by_org)) {
      if (Array.isArray(orgPerms) && orgPerms.includes(permission)) {
        return true;
      }
    }
  }
  return false;
}

export function getDefaultPortalPath(user) {
  if (!user) return '/dashboard';
  // Accueil de pilotage : le SERVEUR dit qui est le dirigeant (`est_dirigeant` de GET /api/auth/me) ; l'écran ne
  // déduit rien. Tout autre compte garde l'atterrissage ci-dessous, inchangé.
  if (user.est_dirigeant === true) return '/pilotage';
  return DEFAULT_PORTAL_PATHS.find(path => {
    const rule = PORTAL_ROUTE_RULES.find(candidate => candidate.match(path));
    if (!rule) return true;
    if (Array.isArray(rule.permissions) && rule.permissions.length) {
      return rule.permissions.some(permission => userHasPermission(user, permission));
    }
    return userHasPermission(user, rule.permission);
  }) || '/dashboard';
}
